import React, { PropsWithChildren, createContext, useContext } from 'react';

import { IComponentKey, IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { WidgetSizes } from 'components/Dashboards/Reporting/reporting.types';

export type PinboardWidgetWrapperContextType = {
    isGenerativeAi: boolean | undefined;
    setIsGenerativeAi: (value: boolean) => void;
    componentKey: IComponentKey | undefined;
    isLoading: boolean;

    onEditWidget?: () => void;
    onToggleNarrative?: () => void;
    onDeleteWidget?: () => void;
    onWidgetChangeSize?: (widgetId: string, widgetSize: WidgetSizes) => void;
    className: string;
    selectedWidgetSize: string;
    isFullscreen?: boolean;
    reportId: number | null;
};

interface Props extends PropsWithChildren {
    value: PinboardWidgetWrapperContextType;
}

const PinboardOrReportWidgetWrapperContext = createContext<PinboardWidgetWrapperContextType>({
    isGenerativeAi: undefined,
    setIsGenerativeAi: () => {},
    componentKey: undefined,
    isLoading: false,
    onEditWidget: undefined,
    onToggleNarrative: undefined,
    onDeleteWidget: undefined,
    onWidgetChangeSize: undefined,
    className: '',
    selectedWidgetSize: '',
    isFullscreen: false,
    reportId: null,
});

export const PinboardOrReportWidgetWrapperProvider = ({ children, value }: Props) => {
    return (
        <PinboardOrReportWidgetWrapperContext.Provider value={value}>
            {children}
        </PinboardOrReportWidgetWrapperContext.Provider>
    );
};

export const usePinboardWidgetWrapperContext = () => {
    return useContext(PinboardOrReportWidgetWrapperContext);
};
